import { AbstractControl, ValidatorFn } from "@angular/forms";

export function   otherTypeValidator(controlName: string, openField: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
        const control = abstractControl.get(controlName);
        const matchingControl = abstractControl.get(openField);

        if (matchingControl!.errors && !matchingControl!.errors?.['otherTypeRequired']) {
            return null;
        }

        if (control!.value === "OTHER" && !matchingControl) {
          const error = { otherTypeRequired: 'Field is required.' };
          matchingControl!.setErrors(error);
          return error;
        } else {
          matchingControl!.setErrors(null);
          return null;
        }
    }
  }